import { PaymentConfirmationComponent } from '../components/dashboard/loggedin-content/screens/payment-confirmation/payment-confirmation.component';
import { MapfreCardComponent } from '../modules/mapfre-design-library/src/lib/_components/wrapper-components/mapfre-card/mapfre-card.component';
import { MapfreInfoDivsComponent } from '../modules/mapfre-design-library/src/lib/_components/section-components/mapfre-info-divs/mapfre-info-divs.component';
import { HeaderComponent } from '../modules/mapfre-design-library/src/lib/_components/global-components/header/header.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { PolicyDataService } from '../_services/data-services/policy-data.service';
import { BillingDataService } from '../_services/data-services/billing-data.service';
import { PaymentServiceService } from '../_services/payment-service/payment-service.service';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, HeaderComponent, MapfreInfoDivsComponent, MapfreCardComponent, PaymentConfirmationComponent],
  selector: 'app-ach-guest-payment-confirm',
  templateUrl: './ach-guest-payment-confirm.component.html',
})
export class AchGuestPaymentConfirmComponent implements OnInit, OnDestroy {
  constructor(
    private policyDataService: PolicyDataService,
    private billingDataService: BillingDataService,
    private paymentService: PaymentServiceService
  ) {}
  isIEBrowser: boolean;
  ngOnInit(): void {
    if (navigator.appVersion.toString().indexOf('.NET') > 0) {
      this.isIEBrowser = true;
    }
  }

  ngOnDestroy() {
    this.paymentService.clear();
    this.policyDataService.clear();
    this.billingDataService.clearBilling();
    this.billingDataService.clearCheckingAccount();
  }
}
